import { ReactNode } from "react";

import { useSidebarContext } from "@/components/General/Sidebar/context/sidebar.context";
import { Depth, useDepth } from "@/context/depth.context";
import { Mapped, useMapped } from "@/context/mapped.context";

type Props = {
    children?: ReactNode;
};

export const Base = ({ children }: Props) => {
    const { categories } = useSidebarContext();
    const { index } = useMapped(0);
    const { depth } = useDepth();

    const category = categories?.at(index + depth);

    if (!category) return null;

    return (
        <Depth initial={index + depth}>
            <Mapped array={category.subCategories ?? []}>{children}</Mapped>
        </Depth>
    );
};
